import { times } from "lodash";

const SKELETON_SECTIONS = [
  { id: "first", cardCount: 2 },
  { id: "second", cardCount: 4 },
];

const DitlCardListSkeleton = () => (
  <div
    className="tw-flex tw-flex-col tw-gap-[12px] tw-animate-pulse motion-reduce:tw-animate-none"
    role="status"
    aria-label="Loading Day in the Life"
  >
    {SKELETON_SECTIONS.map(({ id, cardCount }) => (
      <div key={id} className="tw-flex tw-flex-col tw-gap-[8px]">
        <div className="tw-flex tw-items-center tw-gap-[4px] tw-px-[8px] tw-py-[4px]">
          <div className="tw-w-[12px] tw-h-[12px] tw-rounded-full tw-bg-gray-10" />
          <div className="tw-w-[96px] tw-h-[12px] tw-rounded-full tw-bg-gray-10" />
        </div>
        {times(cardCount, (i) => (
          <div
            key={i}
            className="tw-flex tw-items-center tw-h-[52px] tw-px-[24px] tw-bg-white tw-rounded-[16px] tw-border-[1px] tw-border-solid tw-border-gray-10"
          >
            <div className="tw-w-[55%] tw-h-[14px] tw-rounded-full tw-bg-gray-10" />
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default DitlCardListSkeleton;
